import React from 'react';
import './styles.css';
import { Loader, Nav, Main, AboutMe, MySkills, MyServices, Projects, Contact, Footer, AdminPanel } from './site/main';

function App() {
    return(
        <>
            <Loader />
            <Nav />
            <Main />
            <AboutMe />
            <MySkills />
            <MyServices />
            <Projects />
            <Contact />
            <Footer />
            <AdminPanel />
        </>
    );
}

export default App;